import login from './login';

export default {
  language: 'cs',
  country: 'cz',
  name: 'Čeština',
  embeddedLocale: login,
  flags: ['CZ'],
};
